import { PROVIDER_ACCENT } from '../../lib/graph-visuals';
import { cn } from '../../lib/utils';

/**
 * The cloud (AWS/GCP/…) a recommendation's resource belongs to, as a small
 * provider-accented chip. Shared across every place a recommendation is shown —
 * the board cards, the guidance modal, and the detail page — so the cloud is
 * always visible and styled consistently.
 */
export function ProviderChip({
  provider,
  className,
}: {
  provider?: string | null;
  className?: string;
}) {
  if (!provider) return null;
  const accent = PROVIDER_ACCENT[provider];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-sm px-1 py-px text-[0.5rem] font-bold uppercase tracking-wide',
        !accent && 'bg-surface-2 text-haze',
        className,
      )}
      style={accent ? { backgroundColor: `${accent}22`, color: accent } : undefined}
      title={`Cloud: ${provider}`}
    >
      {provider}
    </span>
  );
}
